import { render, staticRenderFns } from "./ManufacturerDistributorDetails.vue?vue&type=template&id=24591c70&"
import script from "./ManufacturerDistributorDetails.vue?vue&type=script&lang=js&"
export * from "./ManufacturerDistributorDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports